import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    provider: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      required: true,
      default: false
    },
    excluded: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      avatar: null,
      loadingAvatar: false
    };
  },
  methods: {
    toggleUserSelected: function toggleUserSelected(user) {
      this.$emit('toggle-user-selected', user);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.provider === 'microsoft') {
      this.loadingAvatar = true;
      this.$axios.get("integrations/microsoft/users/".concat(this.user.id, "/photo"), {
        responseType: 'blob'
      }).then(function (response) {
        var reader = new FileReader();
        reader.readAsDataURL(response.data);

        reader.onload = function () {
          _this.avatar = reader.result;
        };
      }).catch(function (e) {
        _this.avatar = null;
        console.error('Error loading user avatar', e);
      }).finally(function () {
        _this.loadingAvatar = false;
      });
    }
  }
};